module.exports = __webpack_public_path__ + "20fb0867caa8cff60bd0cb0e162a0ee0.png";